import { BorrowDepositDto, BorrowDepositModel } from '../../modules/Deposit/model/borrow-deposit-model';
import { ReturnDepositDto, ReturnDepositModel } from '../../modules/Deposit/model/return-deposit-model';
import { MoneyAmount } from '../../utils/money';

export const dtoToReturnDepositModel = (dto: ReturnDepositDto): ReturnDepositModel => {
  return {
    ...dto,
    returnedItems: [...dto.returnedItems.map((item) => ({ ...item, amount: MoneyAmount.fromMinUnits(item.amount) }))],
    deposit: {
      ...dto.deposit,
      amount: MoneyAmount.fromMinUnits(dto.deposit.amount),
    },
  };
};

export const dtoToBorrowDepositModel = (dto: BorrowDepositDto): BorrowDepositModel => {
  return {
    ...dto,
    borrowedItems: [
      ...(dto.borrowedItems.map((item) => ({ ...item, amount: MoneyAmount.fromMinUnits(item.amount) })) || []),
    ],
    deposit: {
      ...dto.deposit,
      amount: MoneyAmount.fromMinUnits(dto.deposit.amount),
    },
  };
};
